import { render, staticRenderFns } from "./ModalDescriptionFile.html?vue&type=template&id=c7f13980&scoped=true&external"
import script from "./ModalDescriptionFile.vue?vue&type=script&lang=js"
export * from "./ModalDescriptionFile.vue?vue&type=script&lang=js"
import style0 from "./ModalDescriptionFile.scss?vue&type=style&index=0&id=c7f13980&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f13980",
  null
  
)

export default component.exports